import type { Dispatch, GetState } from 'model/State';
import { Query } from 'redux-first-router';

export const ROUTE = 'mac/LICENSES-PRESELECTED/ROUTE';

export const licensePreselectedRoute = (senNumber: string, params?: Query) => ({
  type: ROUTE,
  payload: {
    senNumber,
  },
  meta: {
    query: params,
  },
});

export const routeIncludeParams = (senNumber: string) => (dispatch: Dispatch, getState: GetState) =>
  dispatch(licensePreselectedRoute(senNumber, getState().location.query));
